import React from 'react';

const Tag = ({ value, handleDelete }) => {
    return (
        <div className='tag'>
            <span className='tag-content'>{value}</span>
            <div className='tag-button' onClick={() => handleDelete()}>
                &times;
            </div>
        </div>
    );
};

export default Tag;
